const styles = theme => ({
  bolFont: {
    marginBottom: theme.spacing.unit * 0.5,
    fontFamily: 'Roboto',
    fontSize: '10px',
    color: 'black'
  },
  bolText1: {
    color: theme.typography.color.main,
    fontFamily: theme.typography.font.main,
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '0.25px',
    lineHeight: '8px',
    margin: 0,
    backgroundColor: 'white'
  },
  textMargin: {
    marginLeft: '5px'
  },
  referenceText: {
    paddingTop: '3px'
  },
  headerText: {
    color: '#0099cc'
  },
  topMargin2: {
    marginTop: '2px'
  },
  topMargin5: {
    marginTop: '5px'
  },
  margin10: {
    marginLeft: '10px'
  },
  noMargin: {
    margin: '0px !important'
  },
  signature: {
    marginTop: '30px'
  },
  checkboxColor: {
    color: '#333333'
  },
  unitText: {
    color: 'black !important'
  },
  unitBorder: {
    border: '1px solid lightGray',
    background: '#FDF8F5'
  },
  proBorder: {
    border: '1px dotted lightGray',
    textAlign: 'center'
  },
  textColor: {
    color: ' #333333'
  },
  unitHeaderText: {
    color: '#404040'
  },
  unitFont: {
    fontSize: '9px'
  },
  tinyFont: { fontSize: '6px' },
  bolTable: {
    width: '100%',
    textAlign: 'left',
    border: '1px solid lightGray',
    background: '#FFFFFF',
    borderSpacing: '0px 5px'
  },
  tableHeader: {
    background: '#DDD5D0',
    height: '20px'
  },
  tableRow: {
    borderSpacing: '22px'
  },
  carrierLogo: {
    maxWidth: '75px',
    position: 'absolute',
    top: '5px',
    right: '5px'
  },
  poweredByLogo: {
    width: '160px',
    height: '40px'
  },
  poweredByBkg: {
    backgroundColor: '#EEECE9'
  },
  poweredByMargin: {
    marginTop: '10px'
  },
  hazMatWarning: {
    color: 'red'
  },
  hazMatContact: {
    color: 'black',
    fontWeight: 'bold'
  },
  hazMatCell: {
    lineHeight: '12px'
  },
  originBackground: {
    backgroundColor: '#ebf6f9'
  },
  destinationBackground: {
    backgroundColor: '#e6fff2'
  },
  originText: {
    background: '#4d79ff',
    color: 'white',
    padding: '3px 3px 3px 3px'
  },
  destinationText: {
    background: '#29a329',
    color: 'white',
    padding: '3px 3px 3px 3px'
  },
  locationGridPadding: {
    padding: '3px 0px 0px 5px !important'
  },
  originColor: {
    border: '1px solid #87CEFA'
  },
  destinationColor: {
    border: '1px solid #00b300'
  },
  positionBottom: {
    position: 'absolute',
    bottom: '10px'
  }
});

export default styles;
